import { Hashtags } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getHashtagThunk, updateHashtagThunk, addHashtagThunk, deleteHashtagThunk } from './thunks';
import { ServerError } from '../../models/errors'

const initialState: Hashtags = {
    hashtags: [],
    editHashtag: {
        id: 0,
        project_id: 0,
        pool_name: '',
        hashtags: '',
        tags_count: 0,
        status: 0
    },
    isHashtagListModalOpen:false,
    inProgress: false,
    error: null
}

const hashtagSlice = createSlice({
    name: 'hashtag',
    initialState,
    reducers: {
        setEditHastagAction: (state, action) => {
            state.editHashtag = action.payload
        },
        resetEditHashAction: (state) => {
            state.editHashtag = initialState.editHashtag
        },
        toggleHashtagListModal: (state)=>{
            state.isHashtagListModalOpen = !state.isHashtagListModalOpen
        }
    },
    extraReducers: (builder) => {
        //get
        builder.addCase(getHashtagThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getHashtagThunk.fulfilled, (state, action) => {
            state.hashtags = action.payload.data
            state.inProgress = false
            state.error = null
        })
        builder.addCase(getHashtagThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })

        //add
        builder.addCase(addHashtagThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(addHashtagThunk.fulfilled, (state, action) => {
            state.hashtags.push(action.payload.data)
            state.inProgress = false
            state.error = null
        })
        builder.addCase(addHashtagThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
        //update
        builder.addCase(updateHashtagThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateHashtagThunk.fulfilled, (state, action) => {
            const index = state.hashtags.findIndex(v => v.id === action.meta.arg.hashtag_pool_id)
            if (index > -1) {
                state.hashtags[index] = action.payload.data
            }
            state.inProgress = false
            state.error = null
        })
        builder.addCase(updateHashtagThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })

        //delete
        builder.addCase(deleteHashtagThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(deleteHashtagThunk.fulfilled, (state, action) => {
            const index = state.hashtags.findIndex(v => v.id === action.payload.data.id)
            if (index > -1) {
                const hash = [...state.hashtags]
                hash.splice(index,1)
                state.hashtags = hash
            }
            state.inProgress = false
            state.error = null
        })
        builder.addCase(deleteHashtagThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
    }
})

export const {
    setEditHastagAction,
    resetEditHashAction,
    toggleHashtagListModal
} = hashtagSlice.actions

export default hashtagSlice.reducer